import type { ReactNode } from 'react';

export function SectionHeading({ description, title }: { description?: string; title: string }) {
  return (
    <div data-campaign-analysis-print-section-heading className="flex max-w-190 flex-col gap-2">
      <h3 className="text-foreground max-w-175 text-2xl leading-tight font-bold tracking-tight">
        {title}
      </h3>
      {description ? (
        <p className="text-muted-foreground text-sm leading-none">{description}</p>
      ) : null}
    </div>
  );
}

export function ReportSection({
  children,
  description,
  id,
  title,
}: {
  children: ReactNode;
  description?: string;
  id?: string;
  title: string;
}) {
  return (
    <section
      id={id}
      data-campaign-analysis-print-section
      className="border-border flex scroll-mt-10 flex-col gap-6 border-b px-5 py-10 last:border-b-0 sm:px-8 sm:py-15"
    >
      <div data-campaign-analysis-print-section-heading className="max-w-3xl">
        <SectionHeading title={title} description={description} />
      </div>
      {children}
    </section>
  );
}
